// extracted by mini-css-extract-plugin
export var btnDefault = "text-button-module--btn-default--d-Lqg";
export var attoiconJobs = "text-button-module--attoicon-jobs--3AFQD";
export var attoiconNotes = "text-button-module--attoicon-notes--zqkHJ";
export var attoiconTimesheets = "text-button-module--attoicon-timesheets--taaTL";
export var attoiconTimesheetsRounded1 = "text-button-module--attoicon-timesheets-rounded1--wxL+t";
export var attoiconMobileTt = "text-button-module--attoicon-mobile-tt--ikBI6";
export var attoiconNamedSites = "text-button-module--attoicon-named-sites--YlKq+";
export var attoiconProfitableBids = "text-button-module--attoicon-profitable-bids--nQR9Y";
export var attoiconDepartments = "text-button-module--attoicon-departments--Wgou1";
export var attoiconTimeline = "text-button-module--attoicon-timeline--7fFkF";
export var attoiconFilters = "text-button-module--attoicon-filters--t-EAc";
export var attoiconVerified = "text-button-module--attoicon-verified--LGZhh";
export var attoiconTimezone = "text-button-module--attoicon-timezone--igH0W";
export var attoiconManualEntries = "text-button-module--attoicon-manual-entries--XTInh";
export var attoiconJobCosting = "text-button-module--attoicon-job-costing--JWkpS";
export var attoiconLocationTracking = "text-button-module--attoicon-location-tracking--S+ipq";
export var attoiconBreak = "text-button-module--attoicon-break--CGoKb";
export var attoiconNightShift = "text-button-module--attoicon-night-shift--o6+XV";
export var attoiconOvertime = "text-button-module--attoicon-overtime--mGrOm";
export var attoiconTimeTracking1 = "text-button-module--attoicon-time-tracking1--OhdSy";
export var attoiconTimeTracking = "text-button-module--attoicon-time-tracking--XeWS5";
export var attoiconLocationHistory = "text-button-module--attoicon-location-history--nW-lQ";
export var attoiconPrivacy = "text-button-module--attoicon-privacy--46pme";
export var attoiconTimeEntryHistory = "text-button-module--attoicon-time-entry-history--lFtz-";
export var attoiconCustomize = "text-button-module--attoicon-customize--H6KUW";
export var attoiconRoundedClock = "text-button-module--attoicon-rounded-clock--yM-xv";
export var attoiconTimeOff = "text-button-module--attoicon-time-off--7O5w2";
export var attoiconNamedLocations = "text-button-module--attoicon-named-locations--fp1lq";
export var attoiconSandClock = "text-button-module--attoicon-sand-clock--83GnM";
export var attoiconBattery = "text-button-module--attoicon-battery--sH5Ib";
export var attoiconSupport = "text-button-module--attoicon-support--DONw+";
export var attoiconHelpSupport = "text-button-module--attoicon-help-support--yxUw3";
export var attoiconWebTt = "text-button-module--attoicon-web-tt--hVfhJ";
export var attoiconArchive = "text-button-module--attoicon-archive--Zv-MA";
export var attoiconEmail = "text-button-module--attoicon-email--x3I82";
export var attoiconKiosk = "text-button-module--attoicon-kiosk--Wzntk";
export var attoiconShare = "text-button-module--attoicon-share--621Xz";
export var attoiconCrew = "text-button-module--attoicon-crew--uwBjy";
export var attoiconTeamActivity = "text-button-module--attoicon-team-activity--W-tw4";
export var attoiconTeam = "text-button-module--attoicon-team--Fg6A4";
export var attoiconWages = "text-button-module--attoicon-wages--MsQXq";
export var attoiconNotification = "text-button-module--attoicon-notification--HHEG4";
export var attoiconAvatar = "text-button-module--attoicon-avatar--s-m1M";
export var attoiconViewMap = "text-button-module--attoicon-view-map--AXk0e";
export var attoiconMovementTracking = "text-button-module--attoicon-movement-tracking--R78ZT";
export var attoiconWageEstimates = "text-button-module--attoicon-wage-estimates--w80cf";
export var attoiconWageEstimatesBold = "text-button-module--attoicon-wage-estimates-bold--M-q+L";
export var attoiconClose = "text-button-module--attoicon-close--4Dahs";
export var attoiconPlus = "text-button-module--attoicon-plus--EUjoF";
export var attoiconMinus = "text-button-module--attoicon-minus--TAC2P";
export var attoiconTick = "text-button-module--attoicon-tick--WsWf8";
export var attoiconArrowLeft = "text-button-module--attoicon-arrow-left--LUSOl";
export var attoiconArrowRight = "text-button-module--attoicon-arrow-right--+CNMo";
export var attoiconArrowDown = "text-button-module--attoicon-arrow-down--4cM+I";
export var attoiconArrowUp = "text-button-module--attoicon-arrow-up--O-OwK";
export var attoiconPlay = "text-button-module--attoicon-play--MPQaD";
export var attoiconLongArrow = "text-button-module--attoicon-long-arrow--xI4Vh";
export var textButton = "text-button-module--textButton--S5lke";